/**
 *
 * Launcher
 *
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { replace } from 'connected-react-router';

import { withWidgetBox } from '../../utils/hoc/withWidgetBox';

export const Launcher = () => <></>;

const withConnect = connect();
const withBox = withWidgetBox({
  onMaximize: () => replace('inquiries'),
});

export default compose(
  withConnect,
  withBox,
)(Launcher);
